<div class="d-flex justify-content-between">
  <div class="center">
    <h1 mat-dialog-title>Peças com NCM inválido</h1>
    <mat-icon
      (click)="showTooltip()"
      #tooltip="matTooltip"
      class="margin-top"
      [matTooltip]="closeOsDialogTooltip"
      [matTooltipHideDelay]="1000"
      color="warn"
      >help</mat-icon
    >
  </div>

  <div class="margin">
    @if (!(layout.isHandset$ | async)) {
      <button mat-raised-button
              type="button"
              [disabled]="form.invalid"
              color="primary"
              (click)="save()">Salvar</button>
    }
    
    <button mat-icon-button type="button" (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div class="table-container {{ (layout.isHandset$ | async) ? 'px-2' : 'm-4' }}">
  <form [formGroup]="form">
    <table mat-table 
           [dataSource]="invalidParts"
           formArrayName="items"
           multiTemplateDataRows>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Código </th>
        <td mat-cell *matCellDef="let row"> {{ row.code }} </td>
      </ng-container>

      <ng-container matColumnDef="description" class="limit">
        <th mat-header-cell *matHeaderCellDef> Descrição </th>
        <td mat-cell *matCellDef="let row"> {{ row.description }} </td>
      </ng-container>

      <ng-container matColumnDef="ncm">
        <th mat-header-cell *matHeaderCellDef> NCM Atual </th>
        <td mat-cell *matCellDef="let row"> {{ row.NCM }} </td>
      </ng-container>

      <ng-container matColumnDef="newNcm">
        <th mat-header-cell *matHeaderCellDef> Novo NCM </th>
        <td mat-cell 
            *matCellDef="let row"
            [formGroupName]="row | getRowIndex: invalidParts">
          <input money
                [decimalPoints]="0"
                [noClass]="true"
                [thousandSeparator]="''"
                type="text"
                formControlName="NCM"
                class="form-control"
                placeholder="Adicione um NCM válido"
                aria-describedby="basic-addon1"/>
          @if (form.controls.items.controls[row | getRowIndex: invalidParts].get("NCM")?.errors) {
            <mat-error>
              {{ form.controls.items.controls[row | getRowIndex: invalidParts].get("NCM")?.errors | error | translate }}
            </mat-error>
          }
        </td>
      </ng-container>

      @if (layout.isHandset$ | async) {
        <ng-container matColumnDef="details">
          <td [attr.colspan]="columns.length"
              mat-cell
              *matCellDef="let row"
              [formGroupName]="row | getRowIndex: invalidParts">
            <div class="form-group pt-3">
              <label>NCM *</label>
              <input money
                    [decimalPoints]="0"
                    [noClass]="true"
                    [thousandSeparator]="''"
                    type="text"
                    formControlName="NCM"
                    class="form-control"
                    placeholder="Adicione um NCM válido"
                    aria-describedby="basic-addon1"/>
              @if (form.controls.items.controls[row | getRowIndex: invalidParts].get("NCM")?.errors) {
                <mat-error class="d-block px-2 mt-1">
                  {{ form.controls.items.controls[row | getRowIndex: invalidParts].get("NCM")?.errors | error | translate }}
                </mat-error>
              }
            </div>
          </td>
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row [class.no-border-bottom]="layout.isHandset$ | async" *matRowDef="let row; columns: columns"></tr>

      @if (layout.isHandset$ | async) {
        <tr mat-row *matRowDef="let row; columns: ['details'];"></tr>
      }
    </table>
  </form>

  @if (layout.isHandset$ | async) {
    <mat-divider></mat-divider>
    
    <button type="button"
            [disabled]="form.invalid"
            color="primary"
            class="button-mobile"
            (click)="save()">Salvar</button>
  }
</div>
